import { buildRecordCardLinkHash } from '../../../routes/utils';
import { CardData } from '../../../store/LinkController/types';

export function getCardLink(data: CardData) {
  const hash = buildRecordCardLinkHash(
    data.tableName,
    data.recordId,
    data.layerName,
  );
  const link = `${window.location.protocol}//${window.location.host}/#${hash}`;

  return link;
}
